import { render, staticRenderFns } from "./goods-list-item.vue?vue&type=template&id=802e1370&scoped=true"
import script from "./goods-list-item.vue?vue&type=script&lang=js"
export * from "./goods-list-item.vue?vue&type=script&lang=js"
import style0 from "./goods-list-item.vue?vue&type=style&index=0&id=802e1370&prod&lang=css"
import style1 from "./goods-list-item.vue?vue&type=style&index=1&id=802e1370&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_61f4c95fbe53a3b57a2489edae5a9b2f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "802e1370",
  null
  
)

export default component.exports